import React from "react";

import {
  FaSearch,
  FaTimes,
} from "react-icons/fa";

export default function TutorialSearchBar({
  query,
  onChange,
  onClear,
  hasQuery,
  totalResults,
  stepCount,
  faqCount,
}) {
  const handleKeyDown = (event) => {
    if (
      event.key === "Escape" &&
      query
    ) {
      onClear();
    }
  };

  return (
    <section className="relative z-20 -mt-1 rounded-[26px] border border-slate-200 bg-white p-4 shadow-[0_20px_60px_-35px_rgba(15,23,42,0.45)] dark:border-slate-800 dark:bg-slate-900 sm:p-5">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center">
        <div className="min-w-0 lg:w-72">
          <h2 className="font-semibold text-slate-900 dark:text-white">
            Comment pouvons-nous vous aider ?
          </h2>

          <p className="mt-1 text-xs leading-5 text-slate-500 dark:text-slate-400">
            Recherchez une fonctionnalité,
            une page ou une question.
          </p>
        </div>

        <div className="relative min-w-0 flex-1">
          <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />

          <input
            id="tutorial-global-search"
            type="search"
            value={query}
            onChange={(event) =>
              onChange(event.target.value)
            }
            onKeyDown={handleKeyDown}
            placeholder="Exemple : inscription, paiement, mot de passe..."
            autoComplete="off"
            className="h-14 w-full appearance-none rounded-2xl border border-slate-200 bg-slate-50 pl-12 pr-12 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-violet-400 focus:bg-white focus:ring-4 focus:ring-violet-100 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:focus:border-violet-500 dark:focus:bg-slate-800 dark:focus:ring-violet-950"
          />

          {query ? (
            <button
              type="button"
              onClick={onClear}
              className="absolute right-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-xl text-slate-400 transition hover:bg-slate-200 hover:text-slate-700 dark:hover:bg-slate-700 dark:hover:text-white"
              aria-label="Effacer la recherche"
            >
              <FaTimes />
            </button>
          ) : null}
        </div>
      </div>

      {hasQuery ? (
        <div className="mt-4 flex flex-wrap items-center gap-2 border-t border-slate-100 pt-4 text-xs dark:border-slate-800">
          <span
            className={`rounded-full px-3 py-1.5 font-semibold ${
              totalResults > 0
                ? "bg-violet-100 text-violet-700 dark:bg-violet-500/15 dark:text-violet-300"
                : "bg-rose-100 text-rose-700 dark:bg-rose-500/15 dark:text-rose-300"
            }`}
          >
            {totalResults > 0
              ? `${totalResults} résultat${
                  totalResults > 1
                    ? "s"
                    : ""
                }`
              : "Aucun résultat"}
          </span>

          {stepCount > 0 ? (
            <span className="rounded-full bg-slate-100 px-3 py-1.5 text-slate-600 dark:bg-slate-800 dark:text-slate-300">
              {stepCount} étape
              {stepCount > 1 ? "s" : ""}
            </span>
          ) : null}

          {faqCount > 0 ? (
            <span className="rounded-full bg-slate-100 px-3 py-1.5 text-slate-600 dark:bg-slate-800 dark:text-slate-300">
              {faqCount} réponse
              {faqCount > 1 ? "s" : ""}
            </span>
          ) : null}
        </div>
      ) : null}
    </section>
  );
}